export default {
  pt: {
    MaintenanceDetailsTab: {
      MaintenanceManagement: 'Planos de Manutenção e Conservação Patrimonial',
      MaintenanceDetails: 'Detalhes do Plano',

      ClientCondominium: 'Cliente/Condomínio:',
      ResponsibleEmployee: 'Colaborador Responsável pelo Plano:',
      ResponsibleEmployeePhone: 'Celular do Colaborador Responsável:',
      DataSource: 'Documento:',
      SystemsCount: 'Quantidade de sistemas:',

      EditMaintenanceDetails: 'Editar Detalhes do Plano de Manutenção',

      Client: 'Cliente',
      Employee: 'Colaborador',
      DataSourceUpdate: 'Documento',
      ResponsiblePhone: 'Celular do Responsável',

      Save: 'Salvar',
      Edit: 'Editar',
      Cancel: 'Cancelar',

      Details: 'Detalhes',
      Systems: 'Sistemas',

      Description: 'Descrição',
    },
  },
  en: {
    MaintenanceDetailsTab: {
      MaintenanceManagement: 'Property Maintenance and Conservation Plans',
      MaintenanceDetails: 'Maintenance Plan Details',

      ClientCondominium: 'Client/Condominium:',
      ResponsibleEmployee: 'Responsible Employee:',
      ResponsibleEmployeePhone: 'Responsible Employee Phone:',
      DataSourceText: 'Data Source:',
      SystemsCount: 'Number of systems:',

      EditMaintenanceDetails: 'Edit Maintenance Plan Details',

      Client: 'Client',
      Employee: 'Employee',
      DataSourceUpdate: 'Data Source',
      ResponsiblePhone: 'Responsible Phone',

      Save: 'Save',
      Edit: 'Edit',
      Cancel: 'Cancel',

      Details: 'Details',
      Systems: 'Systems',

      Description: 'Description',
    },
  },
  es: {
    MaintenanceDetailsTab: {
      MaintenanceManagement:
        'Planes de Mantenimiento y Conservación de Propiedades',
      MaintenanceDetails: 'Detalles del Plan de Mantenimiento',

      ClientCondominium: 'Cliente/Condominio:',
      ResponsibleEmployee: 'Colaborador Responsable:',
      ResponsibleEmployeePhone: 'Teléfono del Colaborador Responsable:',
      DataSource: 'Fecha Fuente:',
      SystemsCount: 'Cantidad de sistemas:',

      EditMaintenanceDetails: 'Editar Detalles del Plan de Mantenimiento',

      Client: 'Cliente',
      Employee: 'Colaborador',
      DataSourceUpdate: 'Fecha Fuente',
      ResponsiblePhone: 'Teléfono del Responsable',

      Save: 'Guardar',
      Edit: 'Editar',
      Cancel: 'Cancelar',

      Details: 'Detalles',
      Systems: 'Sistemas',

      Description: 'Descripción',
    },
  },
}
